module.exports = __webpack_public_path__ + "static/media/runway-supply.e5a80930.svg";